(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teamboard', {
            parent: 'app',
            url: '/team-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'TeamBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/teamboard/teamboard.html',
                    controller: 'TeamBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoHora');
                    $translatePartialLoader.addPart('complexidadeChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
